<template>
<div>
    <orden-view @load-orden="loadOrden"></orden-view>
    <br />
    <div v-if="orden && orden.estado" class="nj-flex">
        <Button label="Aprobar (Gerencia)" icon="doubleCheck" color="green" :activation="activarOpcion('aprobar')" @click="aprobarOrden()" activationCode="aprobar_orden_compra"></Button>
        <Button label="Aprobar (Contabilidad)" icon="doubleCheck" color="green" :activation="activarOpcion('contabilidadAprobar')" @click="contabilidadAprobarOrden()"
            activationCode="aprobar_orden_compra_contable"></Button>
        <button class="nj-button" @click="listarPendientes"><i class="mdi-keyboard-backspace"></i>Regresar</button>
    </div>
</div>
</template>

<script>
import axios from "axios"
import { purchaseStatus } from "../constants/constants"
import { Button } from "../modules/components"
import { ResponseStatus, UsuarioService } from "../services"
import { Confirm, Toast } from "../util"
import OrdenView from "./OrdenView"
export default {
    name: "OrdenApprove",
    data() {
        return {
            orden: {},
        }
    },
    components: {
        OrdenView,
        Button,
    },
    methods: {
        listarPendientes() {
            // this.$router.push("/orden/approve")
            this.$router.push("/orden")
        },
        activarOpcion(opcion) {
            let condicion = false
            switch (opcion) {
                case "aprobar":
                    condicion = this.orden.estado.id_orden_estado === purchaseStatus.CREADO.id
                    break
                case "contabilidadAprobar":
                    condicion = this.orden.estado.id_orden_estado === purchaseStatus.APROBACION_GERENCIA.id
                    break
            }
            return condicion
        },
        aprobarOrden() {
            let idUsuario = this.usuario.usu_id
            Confirm.show({
                message: "¿Desea aprobar la orden?",
                action: () => {
                    axios({
                        method: "POST",
                        url: "/orden/approve",
                        headers: {
                            idOrden: this.$route.params.id,
                            idUsuario: idUsuario,
                        },
                        data: {
                            id_orden_estado: purchaseStatus.APROBACION_GERENCIA.id
                        }
                    }).then(() => {
                        this.$buefy.snackbar.open({
                            message: "Se aprobo la Orden",
                            type: "is-success",
                            position: "is-top",
                            actionText: "OK",
                            indefinite: true,
                            onAction: () => {
                                this.listarPendientes()
                            }
                        })
                    })
                }
            })
        },
        contabilidadAprobarOrden() {
            Confirm.show({
                message: "¿Desea aprobar la orden?",
                action: () => {
                    axios({
                        method: "POST",
                        url: "/orden/approve",
                        headers: {
                            idOrden: this.$route.params.id
                        },
                        data: {
                            id_orden_estado: purchaseStatus.EMITIDO.id
                        }
                    }).then(() => {
                        this.$buefy.snackbar.open({
                            message: "Se aprobo la Orden",
                            type: "is-success",
                            position: "is-top",
                            actionText: "OK",
                            indefinite: true,
                            onAction: () => {
                                this.listarPendientes()
                            }
                        })
                    })
                }
            })
        },
        loadOrden(orden) {
            this.orden = orden
        }
    },
    computed: {
        usuario() {
            return UsuarioService.getUsuario()
        },
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
}
</script>

<style scoped></style>
